import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

interface OrgChartImageProps {
  alt?: string;
  className?: string;
  orgChartImage: string;
  orgChartUrl: string;
  wrapperClassName?: string;
}

const OrgChartImage = ({
  alt,
  className,
  orgChartImage,
  orgChartUrl,
  wrapperClassName,
}: OrgChartImageProps) => {
  return (
    <a href={orgChartUrl}>
      <LazyLoadImage
        alt={alt}
        loading="lazy"
        className={className}
        src={orgChartImage}
        wrapperClassName={wrapperClassName}
      />
    </a>
  );
};

export default OrgChartImage;
